import { IMonitoringRepository } from "../../../../domain/monitoring/monitoring-repository";
import { ChannelTargetData } from "../../../../domain/monitoring/channel-target.data";

export class TargetChartPopupViewModel {
  public visible: boolean;

  public state: "loading" | "ready";
  public channelInputChartUrl: string;
  public selectedTimeMins: number = 60;

  constructor(
    public channelTarget: ChannelTargetData,
    private _monitoringRepository: IMonitoringRepository,
    public windowWidth: string,
    public windowHeight: string,
  ) {}

  showWindow() {
    this.visible = true;
  }

  closeWindow() {
    this.visible = false;
  }

  public showChannelTargetChart() {
    let vertLineEvery = 10;
    let timeTagFormat = "HH:mm";
    let hoursInstead = false;

    if (this.selectedTimeMins === 60 * 24 || this.selectedTimeMins === 60 * 6) {
      vertLineEvery = 1;
      hoursInstead = true;
    } else if (this.selectedTimeMins === 60 * 24 * 7) {
      vertLineEvery = 24;
      hoursInstead = true;
      timeTagFormat = "dd MMMM";
    }

    this.channelInputChartUrl =
      this._monitoringRepository.generateChannelTargetChartUrl(
        this.channelTarget.platformId,
        this.channelTarget.availabilityZoneId,
        1920,
        1080,
        this.selectedTimeMins,
        60 * this.selectedTimeMins,
        timeTagFormat,
        vertLineEvery,
        hoursInstead,
      );
  }
}
